// src/components/PageFooter.jsx
import React from 'react';
import styles from './PageFooter.module.scss';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube } from 'react-icons/fa';
import { motion } from 'framer-motion';
import logo from '../images/logo-footer.png';

// Hover animation settings
const iconHover = {
  scale: 1.2,
  transition: { type: 'spring', bounce: 0.4 },
};

const PageFooter = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.content}>
        <img src={logo} alt="ZoomLion Logo" className={styles.logo} />
        <div className={styles.info}>
          <div className={styles.social}>
            <motion.a
              href="https://www.facebook.com/zoomliontech"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.iconWrapper}
              whileHover={iconHover}
            >
              <FaFacebookF className={styles.icon} />
            </motion.a>
            <motion.a
              href="https://www.instagram.com/zoomlionlatam/"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.iconWrapper}
              whileHover={iconHover}
            >
              <FaInstagram className={styles.icon} />
            </motion.a>
            <motion.a
              href="https://www.linkedin.com/company/zoomlion-latam/"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.iconWrapper}
              whileHover={iconHover}
            >
              <FaLinkedinIn className={styles.icon} />
            </motion.a>
            <motion.a
              href="https://www.youtube.com/@ZoomlionLatam"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.iconWrapper}
              whileHover={iconHover}
            >
              <FaYoutube className={styles.icon} />
            </motion.a>
          </div>
        </div>
      </div>

      <a
        href="https://en.zoomlion.com"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.link}
      >
        © 2025 ZoomLion Heavy Industry SAC
      </a>
      <a
        href="https://zoomlionlatam.com/privacidad/privacidad_peru.pdf"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.link}
      >
        Política de Privacidad de Zoomlion
      </a>
      <a
        href="https://www.mirageconsultores.com"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.link}
      >
        Página desarrollada por Mirage | Agencia & Consultora
      </a>
    </footer>
  );
};

export default PageFooter;